import React from "react";
import { View, StyleSheet } from "react-native";
import BaseMarketingController from "./BaseMarketingController";
import NtMarketingPageContainer from "../components/general/NtMarketingPageContainer";
import NtCrewAppSection from "../components/crewapp/NtCrewAppSection";
import NtCrewFeatureSection from "../components/crewapp/NtCrewFeatureSection";
import NtGuestInfoSection from "../components/guestapp/NtGuestInfoSection";

class CrewAppController extends BaseMarketingController {
  state = {};
  render() {
    return (
      <NtMarketingPageContainer>
        <NtCrewAppSection />
        <NtCrewFeatureSection />
        <NtGuestInfoSection />
      </NtMarketingPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default CrewAppController;
